







































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { PartyPaginator, PartiesState } from '@/stores/parties/types';
import Paginator from '@/components/Paginator.vue';
import { PaginatorEvent, Party } from '@/types';
import { PartyStatus } from '@/enums';
import NewPartyModal from '@/components/modals/NewPartyModal.vue';

const namespace: string = 'parties';

@Component({
    components: {
        Paginator,
        NewPartyModal,
    },
    filters: {
        printPrimaryContact(value: any) {
            const items = [];

            items.push(value.name);
            items.push(value.email);
            items.push(value.phone);

            return items.join(' / ');

        },
    },
})
export default class PartiesView extends Vue {
    @State('parties') parties!: PartiesState;
    @Action('get', { namespace }) getParties: any;
    @Action('post', { namespace }) postPartyData: any;
    @Action('getParty', { namespace }) getParty: any;
    @Action('delete', { namespace }) deleteParty: any;
    @Getter('parties', { namespace }) partiesPaginator!: PartyPaginator;

    fields: any = [
        {
            key: 'name',
            label: 'Name',
            sortable: true,
        },
        {
            key: 'address',
            label: 'Address',
            sortable: true,
        },
        {
            key: 'primary_contact',
            label: 'Contact',
            sortable: true,
        },
        {
            key: 'status',
            label: 'Status',
            sortable: true,
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    currentPage: any = 1;
    perPage: any = 10;
    search: string = '';
    archived: boolean = false;
    sortBy: string = '';
    sortDesc: boolean = true;

    editParty: Party = {
      name: '',
    };

    @Watch('search')
    @Watch('archived')
    onPropertyChanged() {
        this.updateParties();
    }

    @Watch('sortBy')
    @Watch('sortDesc')
    onSortChanged() {
        this.currentPage = 1;
        this.updateParties();
    }

    onRowClicked(item: any, index: number, event: Event) {
        this.$router.push({ name: 'party', params: { id: item.id } });
    }

    mounted() {
        this.currentPage = this.$route.query.page || 1;
        this.perPage = this.$route.query.per_page || 10;
        this.updateParties();
    }

    updateParties() {
        this.getParties({
            page: this.currentPage,
            perPage: this.perPage,
            search: this.search,
            archived: this.archived,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
        });
    }

    updatePaginate(paginatorObject: PaginatorEvent) {
        this.perPage = paginatorObject.perPage;
        this.currentPage = paginatorObject.currentPage;
        this.updateParties();
    }

    deleteItem(id: string) {
        this.deleteParty({
            id,
            page: this.currentPage,
            perPage: this.perPage,
            search: this.search,
            archived: this.archived,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
        });
    }

    get partiesData() {
        return this.partiesPaginator.data;
    }

    get partiesPages() {
        return this.partiesPaginator.metadata;
    }

    openNewPartyModal() {
        this.editParty = {
            name: '',
        };
        this.$nextTick(() => {
            ((this.$refs.newPartyModalRef) as any).showModal();
        });
    }

    openEditPartyModal(id: number) {
        this.editParty = this.partiesData[id];
        this.$nextTick(() => {
            ((this.$refs.newPartyModalRef) as any).showModal();
        });
    }

    saveNewParty(party: Party) {
        if (!party.status) {
            party.status = PartyStatus.active;
        }
        this.postPartyData({
            party,
            page: this.currentPage,
            perPage: this.perPage,
            search: this.search,
            archived: this.archived,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
        });
    }
}
